import React from 'react';
import { Typography } from '@material-ui/core';
import { StyledCard } from './styles';

interface IProps {
  title?: string;
  fitContent?: boolean;
  isOutlined?: boolean;
  children?: React.ReactNode;
}

const SectionCard: React.FC<IProps> = ({ title, fitContent, isOutlined, children }: IProps) => {
  return (
    <StyledCard fit={fitContent} variant={isOutlined ? 'outlined' : 'elevation'}>
      <Typography component="span" variant={'h6'}>
        {title}
      </Typography>
      {children}
    </StyledCard>
  );
};

export default SectionCard;
